// src/services/visitorService.ts
import { ref, onValue, increment, update } from 'firebase/database';
import { db } from '../config/firebase';

export const VisitorService = {
  trackVisit: async (projectId: string) => {
    try {
      console.log('Tracking visit for project:', projectId); // Debug log
      const updates: { [key: string]: unknown } = {
        [`visits/projects/${projectId}`]: increment(1),
        'visits/total': increment(1),
      };

      await update(ref(db), updates);
    } catch (error) {
      console.error('Error tracking visit:', error);
      throw error; // Rethrow to handle in the hook
    }
  },

  getProjectVisits: (projectId: string, callback: (count: number) => void) => {
    console.log('Getting visits for project:', projectId); // Debug log
    const visitsRef = ref(db, `visits/projects/${projectId}`);

    return onValue(
      visitsRef,
      snapshot => {
        const value = snapshot.val();
        console.log('Visit count:', value); // Debug log
        callback(value || 0);
      },
      error => {
        console.error('Error getting visits:', error);
        throw error;
      }
    );
  },

  getTotalVisits: (callback: (count: number) => void) => {
    const totalRef = ref(db, 'visits/total');

    return onValue(
      totalRef,
      snapshot => {
        callback(snapshot.val() || 0);
      },
      error => {
        console.error('Error getting total visits:', error);
        throw error;
      }
    );
  },
};
